import { privateRequest } from "../axios";
import type { User, ApiResponse, GetUsersResponse, GetUsersParams } from "@/types/user";

const ENDPOINTS = {
  USERS: "/users",
  USER_ME: "/users/me",
  USER_ID: (id: string | number) => `/users/${id}`,
  PROFILE_IMAGE: "/users/profile/image",
};

const getUsers = async (params?: GetUsersParams): Promise<GetUsersResponse> => {
  const response = await privateRequest.get<ApiResponse<GetUsersResponse>>(
    ENDPOINTS.USERS,
    { params }
  );
  return response.data.data;
};

const getMyProfile = async (): Promise<User> => {
  const response = await privateRequest.get<ApiResponse<User>>(ENDPOINTS.USER_ME);
  return response.data.data;
};

const getUserById = async (id: string | number): Promise<User> => {
  const response = await privateRequest.get<ApiResponse<User>>(ENDPOINTS.USER_ID(id));
  return response.data.data;
};

const addUser = async (data: Partial<User>): Promise<User> => {
  const response = await privateRequest.post<ApiResponse<User>>(ENDPOINTS.USERS, data);
  return response.data.data;
};

const updateUser = async (id: string | number, data: Partial<User>): Promise<User> => {
  const response = await privateRequest.put<ApiResponse<User>>(ENDPOINTS.USER_ID(id), data);
  return response.data.data;
};

const deleteUser = async (id: string | number): Promise<{ message: string }> => {
  const response = await privateRequest.delete<ApiResponse<any>>(ENDPOINTS.USER_ID(id));
  return { message: response.data.message || "" };
};

const uploadProfileImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await privateRequest.put<ApiResponse<string>>(
    ENDPOINTS.PROFILE_IMAGE,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data.data;
};

const removeProfileImage = async (): Promise<void> => {
  await privateRequest.put<ApiResponse<any>>(ENDPOINTS.PROFILE_IMAGE);
};

const UserService = {
  getUsers,
  getMyProfile,
  getUserById,
  addUser,
  updateUser,
  deleteUser,
  uploadProfileImage,
  removeProfileImage,
};

export default UserService;
